import { Box, Typography, Paper, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function AdminDashboardPage() {
  const { t } = useTranslation()
  return (
    <Box>
      <Typography variant="h4" gutterBottom>{t('navigation.dashboard')}</Typography>
      <Grid container spacing={3}>
        {[
          { label: 'Active Sessions', value: '—' },
          { label: 'Total Users', value: '—' },
          { label: 'Apps Published', value: '—' },
          { label: 'Server Health', value: '—' },
        ].map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.label}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="body2" color="text.secondary">{card.label}</Typography>
              <Typography variant="h4">{card.value}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
